<div class="skeleton-card">
    <!-- Profile Header -->
    <div class="skeleton-header">
        <div class="skeleton circle"></div>

        <div class="skeleton-header-text">
            <div class="skeleton w30 h16 mb8"></div>
            <div class="skeleton w10 h12"></div>
        </div>

        <div class="skeleton btn"></div>
    </div>
</div>
<div class="skeleton-card">
    <!-- List Items -->
    <div class="skeleton-list">
        <div class="skeleton-row" *ngFor="let i of [].constructor(7)">
            <div class="skeleton icon"></div>
            <div class="skeleton w30 h14"></div>
            <div class="skeleton arrow"></div>
        </div>
    </div>
</div>
